module.exports = __webpack_public_path__ + "img/rullet_bg_g.f944a0ef.png";